import React from 'react';
export function NavBar() {
  return <nav className="w-full bg-carbon border-b border-carbon-lighter py-4 px-6 sticky top-0 z-50" data-id="element-179">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-180">
        <img src="https://cdn.magicpatterns.com/uploads/qpWgoNVWVcrUCFCkMWmcru/IMG_6635.jpg" alt="Doctor Ecommerce Logo" className="h-10 md:h-12 object-contain" data-id="element-181" />
        <a href="#contact-form" className="hidden md:inline-flex text-sm font-heading font-bold text-carbon bg-gold px-6 py-2.5 rounded-lg hover:bg-gold-dark transition-colors" data-id="element-182">
          SOLICITAR DIAGNÓSTICO
        </a>
      </div>
    </nav>;
}